import { Text } from "@ttc3k/trekker";
import { useOperatorNameByIdQuery } from "gql/generated.ts";
import { getMultilingualString } from "shared/utils";
import { SimpleErrorNotification, SimpleLoader } from "shared/components";

type OperatorMenuProps = {
  operatorEntityId: string;
};

export const OperatorMenu = ({ operatorEntityId }: OperatorMenuProps) => {
  const { data, error, loading } = useOperatorNameByIdQuery({
    variables: { operatorEntityId },
  });

  if (loading) return <SimpleLoader />;

  if (error) return <SimpleErrorNotification />;

  if (!data || !data.operatorById) {
    return null;
  }

  // TODO : When we know what menu items the operator will have, add the menu here (similar to the organization menu)
  return (
    <>
      <Text visual={"smallSemiBold"}>
        {getMultilingualString(data.operatorById.name)}
      </Text>
    </>
  );
};
